import { Directive, HostListener, Input } from '@angular/core';

/**
 * 누르면 값을 클립보드에 복사한다. 복사한 뒤 잠깐 copied 가 true 가 되어 아이콘을 바꿔 보여 줄 수 있다.
 *
 * <button type="button" [novaCopy]="vin" #c="novaCopy">
 *     <i class="fa-regular" [class.fa-copy]="!c.copied" [class.fa-circle-check]="c.copied"></i>
 * </button>
 */
@Directive({
    selector: '[novaCopy]',
    standalone: true,
    exportAs: 'novaCopy',
})
export class NovaCopyDirective {

    /** 복사할 값. 비어 있으면 아무것도 하지 않는다 */
    @Input('novaCopy') value?: string | null;

    /** 복사 완료 표시 시간(ms) */
    @Input() novaCopyResetMs = 1500;

    /** 방금 복사했는지 */
    copied = false;

    private resetTimer?: ReturnType<typeof setTimeout>;

    @HostListener('click', ['$event'])
    async onClick(event: Event) {
        event.stopPropagation();
        if (!this.value) return;
        await navigator.clipboard.writeText(this.value);
        this.copied = true;
        clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(() => this.copied = false, this.novaCopyResetMs);
    }
}
